import { useMutation, useQueryClient } from '@tanstack/react-query';
import { notifications } from '@mantine/notifications';
import { useTranslation } from 'react-i18next';
import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { AppMedError } from '../../../error/AppMedError.ts';
import { CarePlanTemplatesApi } from '../../../apis/CarePlanTemplatesApi/CarePlanTemplatesApi.ts';
import {
  CarePlanTemplateStatus,
  ICarePlanTemplate,
} from '../CarePlanTemplate.ts';

interface SetStatusVars {
  id: number;
  status: CarePlanTemplateStatus;
}

export function useSetCarePlanTemplateStatus() {
  const queryClient = useQueryClient();
  const { t } = useTranslation();
  return useMutation<ICarePlanTemplate, AppMedError, SetStatusVars>({
    mutationKey: [QueryKeys.carePlanTemplates, 'setStatus'],
    mutationFn: ({ id, status }) => CarePlanTemplatesApi.setStatus(id, status),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [QueryKeys.carePlanTemplates],
      });
      notifications.show({
        color: 'teal',
        message: t('carePlan.notifications.statusUpdated'),
      });
    },
    onError: (error) => {
      notifications.show({
        color: 'red',
        message: error?.message || t('carePlan.notifications.statusError'),
      });
    },
  });
}
